window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    window.dayjs = require('dayjs');
    var utc = require('dayjs/plugin/utc')
    var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
    dayjs.extend(utc)
    dayjs.extend(timezone)
    dayjs.tz.setDefault(dayjs.tz.guess())

    // require('bootstrap');

} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

// 這行會導致 google storage 檔案取得失敗
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

// import * as utils from "./utils"
// Object.assign(window, utils)

import { ElLoading } from 'element-plus'

;(function ($) {
    // 全頻幕讀取
    window.fullPageLoading = (function () {
        // var $fullPageLoading = $('#full-page-loading')

        return function (method) {
            if (method === 'show') {
                window.ElFullPageLoading = ElLoading.service({
                    lock: true,
                    text: "系統載入中",
                });
                // $fullPageLoading.show()
            } else if (method === 'hide') {
                window.ElFullPageLoading && window.ElFullPageLoading.close();
                // $fullPageLoading.hide()
            }
        }
    })()

    // 浮點數位數
    var formatFloat = (window.formatFloat = function (num, pos = 0) {
        var size = Math.pow(10, pos)
        return Math.round(num * size) / size
    })

    var formatCurrency = function (value, float, currency, style='currency') {
        return new Intl.NumberFormat('en', {
            minimumFractionDigits: float,
            maximumFractionDigits: float,
            style: style,
            currency: currency,
        }).format(value)
    }

    // 更新所有價錢至locale價錢 (不綁attribute)
    window.formatCurrency = function (value, currency, hide_symbol=false) {
        if (value === null || value === undefined || typeof value !== 'number') return ''

        const currency_map = {
            "USD": {"symbol":"US$", "point": 2},
            "TWD": {"symbol":"NT$", "point": 0},
            "CNY": {"symbol":"¥", "point": 1},
        }

        let float = 0
        let style = 'currency'
        if (hide_symbol) {
            style = 'decimal'
        }

        if (currency_map[currency]) {
            float = currency_map[currency].point
        }

        return `${formatCurrency(value, float, currency, style)}`
    }

    // Vue.filter('_formatCurrency', function (value, currency) {
    //     return window.formatCurrency(value, currency)
    // })

})(window.jQuery)
